import RecordingType from '../types/enums/recording';

class Recording {
  type?: RecordingType;
  eventId?: string;
  constructor(eventId?: string, type?: RecordingType) {
    this.type = type;
    this.eventId = eventId;
  }
}

export default Recording;
